const getCookie = (key: string): string | null => {
	const match = document.cookie.match(new RegExp(`(^| )${key}=([^;]*)(;|$)`));
	return match ? decodeURIComponent(match[2]) : null;
};

const setCookie = (key: string, value: string, days: number = 365): void => {
	const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
	document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

const getCookieValues = (key: string): string[] => {
	const cookie = getCookie(key);
	return cookie ? cookie.split(',').filter(name => name.trim() !== '') : [];
};

const addValueToCookie = (key: string, value: string): void => {
	const cookieValues = getCookieValues(key);
	const index = cookieValues.indexOf(value);

	if (index >= 0) {
		cookieValues.splice(index, 1);
	}
	cookieValues.unshift(value);

	setCookie(key, cookieValues.join(','));
};

const removeValueFromCookie = (key: string, value: string): void => {
	const cookieValues = getCookieValues(key);
	const index = cookieValues.indexOf(value);

	if (index >= 0) {
		cookieValues.splice(index, 1); 
		setCookie(key, cookieValues.join(',')); 
	}
};

const removeAllValuesFromCookie = (key: string): void => {
	setCookie(key, '', 0);
};

const getGestureUsers = (): string[] => getCookieValues('ges');
const addGestureUser = (username: string): void => addValueToCookie('ges', username);
const removeGestureUserName = (username: string): void => removeValueFromCookie('ges', username);

const getUserNames = (): string[] => getCookieValues('UserName');
const addUserNames = (username: string): void => addValueToCookie('UserName', username);
const removeUserName = (username: string): void => removeValueFromCookie('UserName', username);
const removeAllUserName = (): void => removeAllValuesFromCookie('UserName');

const getRememberMe = (): boolean => getCookie('rememberMe') === 'true';
const setRememberMe = (check: boolean): void => setCookie('rememberMe', check ? 'true' : 'false');

export const cookieService = {
	getCookie,
	setCookie,
	getGestureUsers,
	addGestureUser,
	removeGestureUserName,
	getUserNames,
	addUserNames,
	removeUserName,
	removeAllUserName,
	getRememberMe,
	setRememberMe
};




